import Notification from '../utils/notification';
import jQuery from 'jquery';
import currentUserSession from '@utils/currentUserSession';
const API_URL = import.meta.env['VITE_API_URL'];

function isChromeExtension() {
  return typeof chrome !== 'undefined' && window.chrome && window.chrome.runtime && window.chrome.runtime.id;
}

const handleError = ({ err, reject = () => { }, errorFn = () => { } }) => {
  if (err && err.status === 422) {
    errorFn(err.responseJSON);
    return reject(err.responseJSON);
  } else if (err && err.status === 401) {
    Notification.send({
      text: 'You are not authorized to do that action',
      type: 'error',
    });
  } else if (err && err.status === 404) {
    // location.href = '/not-found';
  } else if (err && err.status === 0) {
    // no-op
  } else {
    Notification.send({
      text: "We're experiencing exceptionally high traffic. Please hang tight as we scale our systems.",
      type: 'error',
    });
  }

  reject(null); // have to let the execution continue otherwise nothing in the method will get called afterwards
};

function detectScreenSize() {
  if (typeof window === 'undefined') return {};

  return {
    screen_width: window.innerWidth,
    screen_height: window.innerHeight,
  };
}

const processData = (data = {}) => {
  let user = currentUserSession();
  data = { ...data, metadata: detectScreenSize(), source: isChromeExtension() ? 'chrome-extension' : 'web' };
  if (user && user.api_token) {
    return { ...data, api_token: user.api_token };
  }

  return data;
};

const get = ({
  url,
  data,
  successFn = () => { },
  errorFn = () => { },
  alwaysFn = () => { },
  withErrorHandling = true,
  withDataProcessing = true,
}) => {
  return fetchRequest({
    url,
    data,
    method: 'GET',
    withErrorHandling,
    withDataProcessing,
    successFn,
    errorFn,
    alwaysFn,
  });
};

const post = ({
  url,
  data,
  successFn = () => { },
  errorFn = () => { },
  alwaysFn = () => { },
  withErrorHandling = true,
  withDataProcessing = true,
}) => {
  return fetchRequest({
    url,
    data,
    method: 'POST',
    withErrorHandling,
    withDataProcessing,
    successFn,
    errorFn,
    alwaysFn,
  });
};

const postJSON = ({
  url,
  data,
  successFn = () => { },
  errorFn = () => { },
  alwaysFn = () => { },
  withErrorHandling = true,
  // do data processing inline below, as we need to stringify
  withDataProcessing = false,
}) => {
  return fetchRequest({
    url,
    data: JSON.stringify(processData(data)),
    method: 'PATCH',
    withErrorHandling,
    withDataProcessing,
    dataType: 'json',
    contentType: 'application/json',
    successFn,
    errorFn,
    alwaysFn,
  });
};

const fetchRequest = (options) => {
  return new Promise((resolve, reject) => {
    jQuery.ajax({
      ...options,
      tryCount: 0,
      retryLimit: 5,
      url: `${API_URL}/api${options.url}`,
      data: options.withDataProcessing ? processData(options.data) : options.data,
      success: (resp) => {
        options.successFn(resp);
        options.alwaysFn();
        resolve(resp);
      },
      error: function (err) {
        if (err && err.status === 0) {
          this.tryCount += 1;

          if (this.tryCount < this.retryLimit) {
            setTimeout(() => {
              jQuery.ajax(this);
            }, 1000);
            return;
          }
        }

        if (options.withErrorHandling) {
          handleError({ err, reject, errorFn: options.errorFn });
        } else {
          options.errorFn(err);
          options.alwaysFn();
          reject(err);
        }
      },
    });
  });
};

export default { post, postJSON, get, handleError, processData, isChromeExtension };
